
import { Component, Prop, Vue } from "vue-property-decorator";
import BaseCard from "@/components/base/BaseCard.vue";
import FormModal from "@/components/base/FormModal.vue";
import TrashBtn from "@/components/base/buttons/TrashBtn.vue";
import SvgPlus from '@/assets/icons/plus.svg';
import SvgClip from '@/assets/icons/clip.svg';
import SvgMagick from "@/assets/icons/magic-wand-light.svg";
import ImageNotesFile from "@/components/base/ImageNotesFile.vue";
import ImageInput from "@/components/base/form/ImageInput.vue";
import TableWithFrontPaginationDesign from "@/components/base/table/TableWithFrontPaginationDesign.vue";
import NotesTooltip from "@/components/base/NotesTooltip.vue";
import { ITableHeader, toBase64 } from "@/utils";
import { Note } from "@/api/types/notes";
import FormCreateNote from "@/components/base/FormCreateNote.vue";

@Component({
    components: {
        FormCreateNote,
        NotesTooltip,
        TableWithFrontPaginationDesign,
        ImageInput,
        ImageNotesFile,
        TrashBtn,
        FormModal,
        BaseCard,
        SvgPlus,
        SvgMagick,
        SvgClip,
    },
})

export default class CardNotes extends Vue {
    @Prop({ default: true }) isAddFile!: boolean;
    @Prop({ default: false }) isLoading!: boolean;
    @Prop({ required: true }) items!: any[];
    @Prop({ default: () => [] }) timeData!: any[];
    @Prop({ required: true }) headers!: ITableHeader[];
    @Prop({ default: 'text' }) keyText!: string;
    @Prop({ default: 'image' }) keyImage!: string;
    @Prop({ default: 10 }) itemsPerPage!: number;
    @Prop({ default: 'Заметки' }) title!: string;
    @Prop({ default: 'Новая заметка' }) formTitle!: string;
    @Prop({ default: 'Создать заметку' }) approveText!: string;

    isShowModal: boolean = false;
    note: string = '';
    image: File | string | null = null;
    editId: number | null = null;
    cashedNote: any = {};
    maxLength = 500;
    rules = [(v: string): any => v.length <= this.maxLength || ''];
    uniqueData = [
        { slot: 'item.text' },
        { slot: 'item.image' },
        { slot: 'item.created_by.name', template: (i: Note): string => i.created_by.name },
    ];

    createNote(): void {
        this.clearEditId();
        this.isShowModal = true;
    }

    async addNote(): Promise<void> {
        this.isShowModal = false;
        const item = this.items.find(i => i.id == this.cashedNote.id);
        if (item) {
            this.cancelEdit(item);
        }
        const base64Image = this.image ? await toBase64(this.image as File) : null;

        this.$emit('add', this.note, base64Image);

        this.note = '';
        this.image = null;
    }

    updateImage(image: any, item: any): void {
        item[this.keyImage] = image;
        // если обновляем картинку, минуя режим редактирования, отправляем запрос на бэк
        if (!this.editId) {
            this.$emit('save', item);
        }
    }

    disabledActions(item: any): boolean {
        return this.editId !== item.id && this.cashedNote && Object.keys(this.cashedNote)?.length > 0;
    }

    deleteNote(item: any): any {
        this.$emit('delete', item);
        this.clearEditId();
    }

    cancelEdit(item: any): void {
        item[this.keyText] = this.cashedNote[this.keyText];
        item[this.keyImage] = this.cashedNote[this.keyImage];
        this.clearEditId();
    }

    editNote(item: any): void {
        this.editId = item.id;
        this.cashedNote = { ...item };
    }

    async saveNote(item: any): Promise<void> {
        if (item[this.keyImage]) {
            // image: null - игнорируется, пустая строка - удаление текущей картинки, строка в base64 - добавляет картинку
            item[this.keyImage] = typeof item[this.keyImage] === 'string' ? null : await toBase64(item[this.keyImage]);
        }
        if (this.isNoteNotEdited(item)) {
            this.cancelEdit(item);
            return;
        }
        this.$emit('save', item);
        this.clearEditId();
    }

    isNoteNotEdited(item: any): boolean {
        return item.image === null && this.cashedNote[this.keyText] === item[this.keyText];
    }

    clearEditId(): void {
        this.editId = null;
        this.cashedNote = {} as any;
    }

    updateText(text: string, note: any): void {
        text = text.trim();
        if (text.length > 500) text = text.slice(0, this.maxLength);
        note[this.keyText] = text;
    }
}

